import httpClient from "@/services/HttpService";

export default {

    findByContesto: async (contesto) => {
        return (await httpClient.get(`/tipo-controllo/peso/contesto/${contesto}`)).data;
    },

}
